


































































































































import { Component, Mixins } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import { ICryptoAccount, IfetchCryptoAccount } from '@/interface/CryptoInterface';
import cryptoAccountTable from '@/data/CryptoAccountData';
import cryptoAccountBody from '@/components/Table/CryptoAccountBody.vue';
import cryptoAccountModule from '@/store/modules/CryptoAccount';
import GeneralModule from '@/store/modules/General';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import S3 from 'aws-s3';

@Component({
  components: {
    Table,
    cryptoAccountBody,
  },
})
export default class CryptoAccountView extends Mixins(ErrorHandleMixin) {
  cryptoAccountInstance = getModule(cryptoAccountModule, this.$store);

  TableHeadcryptoAccount = cryptoAccountTable.TableHeadCryptoAccount;

  GeneralInstance = getModule(GeneralModule, this.$store);

  config = {
    bucketName: 'image-uploader-amb',
    dirName: 'qrImages',
    region: 'ap-southeast-1',
    accessKeyId: 'AKIAQIRWMGKG54CLGNPW',
    secretAccessKey: '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',
  };

  S3Client = new S3(this.config);

  modalAddCrypto = false;

  modalRemoveCrypto = false;

  locationFile: any = null;

  fileData: any = null;

  cryptoData: ICryptoAccount = {
    _id: '',
    address: '',
    network: '',
    currency: 'USDT',
    imagePath: '',
  };

  crytptoFetch: Array<IfetchCryptoAccount> = [
    {
      _id: '',
      address: '',
      network: '',
      currency: '',
      imagePath: '',
    },
  ];

  mode = '';

  created() {
    this.fetchCryptoAccount();
  }

  async fetchCryptoAccount() {
    this.GeneralInstance.toggleLoading(true);
    const { data, status } = await this.cryptoAccountInstance.FetchCryptoAccount();
    this.crytptoFetch = data;
    this.checkError(status);
    this.GeneralInstance.toggleLoading(false);
  }

  openModal(item: any, index: number) {
    this.mode = index > -1 ? 'Update' : 'Create';
    if (this.mode === 'Update') {
      this.modalAddCrypto = !this.modalAddCrypto;
      this.cryptoData = {
        _id: item._id,
        address: item.address,
        network: item.network,
        currency: item.currency,
        imagePath: item.imagePath,
      };
    } else {
      this.resetDate();
    }
  }

  resetDate() {
    this.cryptoData = {
      _id: '',
      address: '',
      network: '',
      currency: 'USDT',
      imagePath: '',
    };
  }

  uploadImage(files: [any]) {
    this.GeneralInstance.toggleLoading(true);
    const [file] = files;
    this.locationFile = URL.createObjectURL(file);
    this.fileData = file;
    this.GeneralInstance.toggleLoading(false);
  }

  async onSubmit() {
    this.GeneralInstance.toggleLoading(true);
    const newFileName = 'img';
    if (this.fileData) {
      const resS3 = await this.S3Client.uploadFile(
        this.fileData,
        `${newFileName}_${this.fileData.lastModified}`,
      );
      this.cryptoData.imagePath = resS3.location;
    }
    const { status } = await this.cryptoAccountInstance[`${this.mode}CryptoAccount`](
      this.cryptoData,
    );
    this.checkError(status);
    this.mode = '';
    this.resetDate();
    this.fetchCryptoAccount();
    this.GeneralInstance.toggleLoading(false);
  }

  async remove(item: any) {
    this.modalRemoveCrypto = !this.modalRemoveCrypto;
    this.cryptoData = {
      _id: item._id,
      address: item.address,
      network: item.network,
      currency: item.currency,
      imagePath: item.imagePath,
    };
  }

  async submitRemove() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.cryptoAccountInstance.DeleteCryptoAccount(this.cryptoData);
    this.checkError(res);
    this.modalRemoveCrypto = false;
    this.resetDate();
    this.fetchCryptoAccount();
    this.GeneralInstance.toggleLoading(false);
  }
}
